import BaseMygocuApiService from './BaseMygocuApiService';
import axios from 'axios';

const PASARELAPAGO_API_VERSION = 'v1';
const PASARELAPAGO_API_BASEPATH_URL = '/pasarelaPago/' + PASARELAPAGO_API_VERSION;

class PasarelaPagoApiService {
  /**
   * Crea en el sistema la solicitud para el cobro inicial de una reserva dada y devuelve la informacion necesaria
   * para redirigir a la pasarela de pago
   *
   * @param reservaId
   * @param codigoDescuento
   * @param pagoUnico
   * @param datosFiscales - ID de los datos fiscales seleccionados (opcional)
   * @returns {Promise<*>} Objeto que contiene todos los datos necesarios para hacer la redireccion a la pasarela de pago
   *
   */
  async solicitaCobroInicial(reservaId, codigoDescuento, pagoUnico, datosFiscales = null) {
    const ppSolicitudCobroDTO = {
      grupoReservas: reservaId,
      codigoDescuento,
      pagoUnico,
    };

    if (datosFiscales !== null) {
      ppSolicitudCobroDTO.datosFiscales = datosFiscales;
    }

    return await BaseMygocuApiService.post(
      PASARELAPAGO_API_BASEPATH_URL.concat('/solicitaCobroInicial'),
      ppSolicitudCobroDTO
    );
  }

  async solicitaCobroInicialInvitacionGrupo(invitacionId, pagoUnico, codigoDescuento = null) {
    const ppSolicitudCobroDTO = {
      invitacionGrupo: invitacionId,
      codigoDescuento,
      pagoUnico,
    };
    return await BaseMygocuApiService.post(
      PASARELAPAGO_API_BASEPATH_URL.concat('/invitacionGrupo/solicitaCobroInicial'),
      ppSolicitudCobroDTO
    );
  }

  async solicitaCobroSucesivo(reservasIds, applyDraft, codigoDescuento, pagoUnico, datosFiscales = null) {
    const ppSolicitudCobroDTO = {
      reservasIds,
      applyDraft,
      codigoDescuento,
      pagoUnico,
    };

    if (datosFiscales !== null) {
      ppSolicitudCobroDTO.datosFiscales = datosFiscales;
    }

    return await BaseMygocuApiService.post(
      PASARELAPAGO_API_BASEPATH_URL.concat('/solicitaCobroSucesivo'),
      ppSolicitudCobroDTO
    );
  }

  async solicitaContinuarSinPagar(reservasIds) {
    const ppSolicitudCobroDTO = {
      reservasIds,
    };
    return await BaseMygocuApiService.post(
      PASARELAPAGO_API_BASEPATH_URL.concat('/solicitaContinuarSinPagar'),
      ppSolicitudCobroDTO
    );
  }

  async getInfoPago(cobroUuid, orderCode, success) {
    return await BaseMygocuApiService.get(PASARELAPAGO_API_BASEPATH_URL.concat('/infoPago'), {
      cobroUuid: cobroUuid,
      orderCode: orderCode,
      success: success,
    });
  }

  async generarPagoBack(url, version, parametros, firma) {
    var bodyFormData = new FormData();
    bodyFormData.append('version', version);
    bodyFormData.append('parametros', parametros);
    bodyFormData.append('firma', firma);
    return await axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new PasarelaPagoApiService();
